<template>
  <div class="edit-video-box">
    <el-dialog
      :title="title1"
      :visible.sync="dialogVisible"
      width="350px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="params"
        :rules="rules"
        label-width="90px"
        :label-position="labelPosition"
      >
        <el-form-item label="置顶类型:" prop="topLevel">
          <el-select v-model="params.topLevel" size="small" placeholder="请选择处理状态" clearable>
            <el-option
              v-for="item in topLevels"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间:" prop="topStartTime">
            <el-date-picker
              v-model="params.topStartTime"
              type="datetime"
              placeholder="选择日期时间">
            </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间:" prop="topEndTime">
            <el-date-picker
              v-model="params.topEndTime"
              type="datetime"
              placeholder="选择日期时间">
            </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from '@/api'
export default {
  data() {
    return {
      labelPosition: 'left',
      dialogVisible: false,
      title1: '',
      type: '',
      flag: false,
      id: '',
      topLevels: [
        { label: '全局置顶', value: 20 },
        { label: '城市置顶', value: 10 },
        { label: '城市次级置顶', value: 9 }
      ],

      params: {
        topLevel: '',
        topStartTime: '',
        topEndTime: ''
      },

      // 表单验证规则
      rules: {
        topLevel: [
          { required: true, message: '请选择置顶类型', trigger: 'blur' }
        ],
        topStartTime: [
          { required: true, message: '请选择开始时间', trigger: 'blur' }
        ],
        topEndTime: [
          { required: true, message: '请选择结束时间', trigger: 'blur' }
        ]
      }
    }
  },

  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true
          this.updateLoufeng()
        } else {
          return false
        }
      })
    },
    updateLoufeng() {
      const params = Object.assign({}, this.params, {
        id: this.id
      })
      API.updateLoufeng(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.$emit('handlerChannelList')
          } else {
            if (res.tip) {
              this.$message.error(res.tip)
            } else {
              this.$message.error('操作失败')
            }
          }
          this.handleClose()
          this.flag = false
        })
        .catch(() => {
          this.handleClose()
          this.flag = false
        })
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false
      this.$refs.form.resetFields()
      this.params = {
        processedReceipt: '',
        processingStatus: ''
      }
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(data) {
      this.dialogVisible = true
      this.params = data
      this.id = data.id
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-video-box {
  .item-box {
    margin-left: 28px;
    width: 100%;
    display: flex;
    .item1 {
      flex: 1;
      .upload {
        position: relative;
        top: 35px;
        left: -90px;
      }
    }
    .item2 {
      flex: 3;
      width: 250px;
      position: relative;
      top: 0px;
      left: -60px;
    }
  }
}
</style>
